import React from 'react';

export default function FetchLoader() {
    return (
        <span className="fetch-loader-container">
            <span className="fetch-loader"></span>
        </span>
   )
}